import store from './withLocalStorage';

export default store;
